export default {
    title: `Your social networks`,
    delete: `Delete this account`,
    edit: 'Edit',
};
